import type * as Flows from './types.no-deps'
import { type Dictionary, dictMerge, emptyDict } from '../../../shared/lib/functional/dictionary.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { map, reduce } from '../../lib/functional/array.no-deps'

export function isDropdownChoice(choice: Flows.Choice): choice is Flows.DropdownChoice {
    return 'value' in choice
}

export function findDropdownChoiceValue(choices: Flows.DropdownChoice[], choiceId: Flows.ChoiceId) {
    return choices.find((c) => c.id === choiceId)?.value
}

export function findChoiceLabel(choices: Flows.Choice[], choiceId: Flows.ChoiceId) {
    const choice = choices.find((c) => c.id === choiceId)
    return choice.label
}

export function getElementChoiceLookup(element: Flows.Element | Flows.NestedElement): Dictionary<string> | null {
    if (
        element.type === 'radio' ||
        element.type === 'checkbox' ||
        element.type === 'dropdown' ||
        element.type === 'image-select'
    ) {
        return pipe(
            element.choices,
            map((choice) => ({ [choice.id]: choice.label })),
            reduce(emptyDict(), dictMerge)
        )
    }
    return null
}
